module.exports = __webpack_public_path__ + "6856cf801663af189027f88d5f646798.ttf";